export default () => ({
  trigger: {
    name: 'order_status_element.click_customer_service',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'customer_service',
      },
    },
  },
});
